import * as api from "@/api/williams/project";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useProject(projectId?: string) {
  const id = projectId ?? "";

  return useQuery({
    enabled: Boolean(id),
    queryKey: queryKeys.project.single(id),
    queryFn: () => api.getProjectById(id),
  });
}
